
import Controls from './controls';
import Elements from './elements'; 
import Layouts from './layouts';
import Icons from './icons';

export default  {
    Controls,
    Elements,
    Layouts,
    Icons
};